import { Map as IMap } from 'immutable';

import { getNowTimestamp } from '../utils/timeUtils';


export const SESSION_LIFETIME = 1000 * 60 * 60 * 24; 
export const sessionLifetimeDeserializer = (state, payload) => {
    const lastActionTimestamp = payload.lastAction;
    if (lastActionTimestamp) {
        const now = getNowTimestamp();
        const sessionExpired = (now - lastActionTimestamp) > SESSION_LIFETIME;
        if (sessionExpired) {
            return state;
        }
    }

    
    const { intl } = payload;
    delete payload.intl;
    return state.merge(payload).set('intl', intl);
};



export const CLEAR_STOREFRONT_SESSION = '@@storefront/CLEAR_STOREFRONT_SESSION';
export const SET_STOREFRONT_SESSION = '@@storefront/SET_STOREFRONT_SESSION';
export const GET_OR_CREATE_STOREFRONT_SESSION = '@@storefront/GET_OR_CREATE_STOREFRONT_SESSION';
export const CAPI_SESSION_CALL_INDICATOR = '@@storefront/CAPI_SESSION_CALL_INDICATOR';
export const HOME_PAGE_INDICATOR = '@@storefront/HOME_PAGE_INDICATOR';


const sessionReducer = (state = IMap({}), action) => {
    switch (action.type) {
        case SET_STOREFRONT_SESSION: {
            const { sessionKey } = action;
            return state.set('sessionKey', sessionKey);
        }
        case CLEAR_STOREFRONT_SESSION:
            return state.delete('sessionKey');
        default:
    }
    return state;
};



export const isGridViewHomePageReducer = (state = IMap({ isGridViewHomePageFlag: false }), action) => {
    switch (action.type) {
        case HOME_PAGE_INDICATOR:
            return state.set('isGridViewHomePageFlag', action.flag);
        default:
    }
    return state;
};





export const capiCallReducer = (state = IMap({ sessionCallInProgress: false }), action) => {
    switch (action.type) {
        case CAPI_SESSION_CALL_INDICATOR:
            return state.set('sessionCallInProgress', action.flag);
        default:
    }
    return state;
};



export const clearStorefrontSession = () => ({
    type: CLEAR_STOREFRONT_SESSION
});

export const setStorefrontSession = sessionKey => ({
    type: SET_STOREFRONT_SESSION,
    sessionKey
});

export const getOrCreateStorefrontSession = () => ({
    type: GET_OR_CREATE_STOREFRONT_SESSION
});

export const capiSessionCallIndicator = (flag = true) => ({
    type: CAPI_SESSION_CALL_INDICATOR,
    flag
});

export const homePageIndicator = flag => ({
    type: HOME_PAGE_INDICATOR,
    flag
});

export default sessionReducer;
